import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Layout from "layouts/DashboardManage";
import { addTeam } from "store/actions/teamAction";
import { getAllUsers } from "store/actions/userAction";
import has from "lodash/has";
import { notifyApiError } from "components/Notification";
import SubmitButton from "components/Forms/Buttons/Submit";
import Textbox from "components/Forms/Elements/Textbox";
import DualMultiSelect from "components/Forms/Elements/DualMultiSelect";
import { SpinnerSyncBlock } from "components/Spinner";
import Translate from "helpers/Translate";

export class Add extends Component {
  state = {
    name: "",
    batch_size: 0,
    searchKeyword: "",
    users: []
  };

  componentDidMount() {
    this.props.getAllUsers({
      clientId: this.props.match.params.clientId,
      showUnused: true,
      userType: "web"
    });
  }

  componentDidUpdate(prevProps) {
    // When the new team is created successfully, we will redirect to step 2
    if (
      prevProps.addTeamResponse !== this.props.addTeamResponse &&
      has(this, "props.addTeamResponse.id")
    ) {
      // Redirect to manage page
      return this.props.history.push(
        `/manage/clients/${this.props.match.params.clientId}/teams/manage`
      );
    }

    // When there was a problem creating the new Team
    if (
      prevProps.errorTeam !== this.props.errorTeam &&
      this.props.errorTeam &&
      Object.keys(this.props.errorTeam).length > 0
    ) {
      notifyApiError(this.props.errorTeam);
    }
  }

  handleChange = e => {
    const target = e.target;
    this.setState(prevState => ({
      ...prevState,
      [target.name]: target.value
    }));
  };

  handleCreate = () => {
    this.props.addTeam({
      name: this.state.name,
      batch_size: this.state.batch_size,
      client: this.props.match.params.clientId,
      users: this.state.users.map(u => u.value)
    });
  };

  render() {
    return (
      <Layout>
        {this.props.isLoading && <SpinnerSyncBlock />}
        <div className="add-edit">
          <h1 className="title mb-30">{Translate({ id: "add_team" })} </h1>

          <div className="center-form">
            <div className="form-wrapper">
              <div className="form-group mb-20">
                <label htmlFor="name">{Translate({ id: "team_name" })} </label>
                <Textbox
                  type="text"
                  placeholder="Team A"
                  id="name"
                  name="name"
                  fieldValue={this.state.name}
                  onChange={this.handleChange}
                  onReturnKey={this.handleCreate}
                  errors={this.props.errorTeam}
                  errorKey="name"
                  formErrorClass="form-error"
                />
              </div>
              <div className="form-group mb-20">
                <label htmlFor="batch_size">{Translate({ id: "batch_size" })} </label>
                <Textbox
                  type="text"
                  placeholder="10"
                  id="batch_size"
                  name="batch_size"
                  fieldValue={this.state.batch_size}
                  onChange={this.handleChange}
                  onReturnKey={this.handleUpdate}
                  errors={this.props.errorTeam}
                  errorKey="batch_size"
                  formErrorClass="form-error"
                />
              </div>
              <DualMultiSelect
                selectItemsLabel={Translate({ id: "search_users" })}
                selectedItemsLabel={Translate({ id: "selected_users" })}
                placeholder={Translate({ id: "search_by_name" })}
                inputFieldValue={this.state.searchKeyword}
                onSearch={e => {
                  this.props.getAllUsers({
                    clientId: this.props.match.params.clientId,
                    showUnused: true,
                    userType: "web",
                    name: e.target.value
                  });
                  this.setState({
                    searchKeyword: e.target.value
                  });
                }}
                onSearchReturnKey={this.handleCreate}
                onRemoveItem={userId => {
                  this.setState({
                    users: this.state.users.filter(
                      item => item.value !== userId
                    )
                  });
                }}
                onSelect={item => {
                  this.setState(prevState => {
                    let users = prevState.users;
                    users.push({
                      label: item.label,
                      tooltip: item.tooltip,
                      value: item.value
                    });
                    return {
                      users
                    };
                  });
                }}
                errors={this.props.errorTeam}
                errorKey="users"
                items={
                  has(this, "props.users.data")
                    ? this.props.users.data.map(item => ({
                        label: item.fullname,
                        tooltip: item.email,
                        value: item.id
                      }))
                    : []
                }
                selectedItems={this.state.users}
              />

              <div className="clear mb-10"></div>
              <div className="alert alert-info">
                <ul>
                  <li className="mb-5">
                    -&nbsp;
                    {Translate({
                      id: "only_users_with_type_web_will_be_listed_here"
                    })}
                  </li>
                  <li>
                    -{" "}
                    {Translate({
                      id: "a_user_assigned_to_another_team_for_a_client_will_not_be_listed_here"
                    })}
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="save-cancel-buttons">
            <Link
              to={`/manage/clients/${this.props.match.params.clientId}/teams/manage`}
              className="btn manage-btn-cancel"
            >
              <i className="far fa-times-circle mr-10"></i> {Translate({ id: "cancel" })}
            </Link>

            <SubmitButton
              className="btn btn-primary manage-btn-save"
              buttonIconClass="fas fa-save mr-10"
              buttonText={Translate({ id: "save_changes" })}
              btnId="update"
              isLoading={this.props.isLoading}
              handleSubmit={this.handleCreate}
            />
          </div>
        </div>
      </Layout>
    );
  }
}

Add.propTypes = {
  addTeam: PropTypes.func.isRequired,
  getAllUsers: PropTypes.func,
  users: PropTypes.object,
  addTeamResponse: PropTypes.object,
  errorTeam: PropTypes.object,
  isLoading: PropTypes.bool
};

const mapStateToProps = state => {
  return {
    addTeamResponse: state.team.addTeam,
    users: state.user.getAllUsers,
    errorTeam: state.team.errorTeam,
    isLoading: state.user.isLoadingUser
  };
};

export default connect(mapStateToProps, { addTeam, getAllUsers })(Add);
